// src/router/index.js

import { createRouter, createWebHistory } from 'vue-router';
import AdminLayout from '../layouts/AdminLayout.vue';
import Home from '../components/DashboardPage.vue';
import Users from '@/components/pages/admin/user/UsersPage.vue';
import EditUserPage from "@/components/pages/admin/user/EditUserPage.vue";
import Trips from '@/components/pages/admin/trip/TripsPage.vue';
import Reports from '../components/pages/admin/report/ReportsPage.vue';
import LoginPage from '../components/pages/auth/LoginPage.vue';
import NotFound from '../components/NotFoundPage.vue';
import AboutPage from "@/components/pages/about/AboutPage.vue";
import MapPage from "@/components/pages/admin/map/MapPage.vue";
import NewTripPage from "@/components/pages/admin/trip/NewTripPage.vue";
import TripDetailsPage from "@/components/pages/admin/trip/TripDetailsPage.vue";
import ProfilePage from "@/components/pages/global/ProfilePage.vue";
import EditProfilePage from "@/components/pages/global/EditProfilePage.vue";
import RegisterPage from "@/components/pages/auth/RegisterPage.vue";
import {APP_NAME} from "@/globals/contants";
import DriversPage from "@/components/pages/admin/driver/DriversPage.vue";
import EditDriverPage from "@/components/pages/admin/driver/EditDriverPage.vue";
import {getUserRole} from "@/utils/roleHelpers";
import UserTripsPage from "@/components/pages/user/trip/UserTripsPage.vue";
import DashboardUserPage from "@/components/pages/user/dashboard/DashboardUserPage.vue";
import UserNewTripPage from "@/components/pages/user/trip/UserNewTripPage.vue";
import CarsPage from '@/components/pages/admin/car/CarsPage.vue';
import NewCarPage from "@/components/pages/admin/car/NewCarPage.vue";
import EditCarPage from "@/components/pages/admin/car/EditCarPage.vue";
import NewDriverPage from "@/components/pages/admin/driver/NewDriverPage.vue";
import LogoutPage from "@/components/pages/global/LogoutPage.vue";
import InitializingPage from "@/components/pages/global/InitializingPage.vue";
import UnAuthorizedPage from "@/components/UnAuthorizedPage.vue";
import UserTripDetailsPage from "@/components/pages/user/trip/UserTripDetailsPage.vue";
import apiClient from "@/api/axios";
import RecoveryAccount from "@/components/pages/auth/RecoveryAccount.vue";

const routes = [
  {
    path: '/',
    component: AdminLayout,
    children: [
      {
        path: 'initializing',
        name: 'Initializing',
        component: InitializingPage,
        meta: { title: 'Loading Dashboard' },
      },
      {
        path: 'logout',
        name: 'Logout',
        component: LogoutPage,
        meta: { title: 'Logging out' },
      },
      {
        path: 'dashboard',
        name: 'DashboardAdmin',
        component: Home,
        meta: { title: 'Dashboard'  , roles: ['admin']},
      },
      {
        path: 'user/dashboard',
        name: 'DashboardUser',
        component: DashboardUserPage,
        meta: { title: 'Dashboard' },
      },
      {
        path: 'users',
        name: 'Users',
        component: Users,
        meta: { title: 'Users' ,roles: ['admin']},
      },
      {
        path: 'users/:id/edit',
        name: 'EditUser',
        component: EditUserPage,
        meta : { title: 'Edit User' , roles: ['admin']}
      },
      {
        path: 'users/:id',
        name: 'InfoUser',
        component: EditUserPage,
        meta : { title: 'User Info' }
      },
      {
        path: 'trips',
        name: 'Trips',
        component: Trips,
        meta: { title: 'Trips' , roles: ['admin']},
      },
      {
        path: 'user/trips',
        name: 'UserTrips',
        component: UserTripsPage,
        meta: { title: 'Trips' },
      },
      {
        path: 'trips/:status',
        name: 'TripsByStatus',
        component: Trips,
        meta: { title: 'Trips' , roles: ['admin']},
      },
      {
        path: 'user/trips/:status',
        name: 'UserTripsByStatus',
        component: UserTripsPage,
        meta: { title: 'Trips' },
      },
      {
        path: 'trips/create',
        name: 'NewTrip',
        component: NewTripPage,
        meta: { title: 'New Trip', roles: ['admin'] },
      },
      {
        path: 'user/trips/create',
        name: 'UserNewTrip',
        component: UserNewTripPage,
        meta: { title: 'New Trip' },
      },
      {
        path: 'trips/:id/info',
        name: 'TripDetails',
        component: TripDetailsPage,
        meta : { title: 'Trip Details', roles: ['admin']}
      },
      {
        path: 'user/trips/:id/info',
        name: 'UserTripDetails',
        component: UserTripDetailsPage,
        meta : { title: 'Trip Details' }
      },
      {
        path: 'reports',
        name: 'Reports',
        component: Reports,
        meta: { title: 'Reports' },
      },
      {
        path: 'about',
        name: 'About',
        component: AboutPage,
        meta: { title: 'About' },
      },
      {
        path: 'realtime',
        name: 'Realtime',
        component: MapPage,
        meta : { title: 'Realtime Map'  , roles: ['admin']}
      },
      {
        path: 'profile',
        name: 'Profile',
        component: ProfilePage,
        meta : { title: 'Profile' }
      },
      {
        path: 'profile/edit',
        name: 'ProfileEdit',
        component: EditProfilePage,
        meta : { title: 'Edit Profile' }
      },
      {
        path: 'drivers',
        name: 'Drivers',
        component: DriversPage,
        meta: { title: 'Drivers'  , roles: ['admin']},
      },
      {
        path: 'drivers/:id/edit',
        name: 'EditDriver',
        component: EditDriverPage,
        meta : { title: 'Edit Driver'  , roles: ['admin']}
      },
      {
        path: 'drivers/create',
        name: 'NewDriver',
        component: NewDriverPage,
        meta: { title: 'New Driver'  , roles: ['admin']},
      },
      {
        path: 'cars',
        name: 'Cars',
        component: CarsPage,
        meta: { title: 'Cars'  , roles: ['admin']},
      },
      {
        path: 'cars/create',
        name: 'NewCar',
        component: NewCarPage,
        meta: { title: 'New Car'  , roles: ['admin']},
      },
      {
        path: 'cars/:id/edit',
        name: 'EditCar',
        component: EditCarPage,
        meta : { title: 'Edit Car'  , roles: ['admin']}
      }
    ],
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
    meta: { title: 'Login' },
  },
  {
    path: '/register',
    name: 'RegisterPage',
    component: RegisterPage,
    meta: { title: 'Register' },
  },
  {
    path: "/forgot-password",
    name: "RecoveryAccount",
    component: RecoveryAccount,
    meta: { title: 'Recovery account' },
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: UnAuthorizedPage,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { title: '404 Not Found' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Guardias de ruta para proteger las rutas que requieren autenticación
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('authToken');

  if (to.meta.requiresAuth && !token) {
    next('/login');
  } else if (to.path === '/login' && token) {

    // Verificacion del token
    // Obtenemos el token almacenado en localStorage
    const token = localStorage.getItem('authToken');

    // Si no existe token, redirigimos al login
    if (!token) {
      return next('/login');
    }

    try {
      // Realizamos una petición al endpoint de verificación del token
      await apiClient.get('/auth/verify-token');
      // Si la verificación es exitosa, permitimos la navegación
      next();
    } catch (error) {
      // Si la verificación falla, eliminamos los datos almacenados y redirigimos al login
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      next('/login');
    }

    next('/dashboard');
  } else {

    if (to.meta && to.meta.roles) {
      const allowedRoles = to.meta.roles;
      const currentRole = getUserRole();
      // Si el rol del usuario no está en los roles permitidos, se redirige a "No autorizado"
      if (!allowedRoles.includes(currentRole)) {
        return next({name: 'Unauthorized'});
      }
    }

    if (to.meta.title) {
      document.title = `${APP_NAME} - ${to.meta.title}`;
    }
    next();
  }
});

export default router;
